import React, { useState } from 'react';
import { Modal, Form, Button, Image } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import { toast, ToastContainer } from 'react-toastify';


const EditProfileModal = ({ showModal, handleClose, login }) => {
    const [formData, setFormData] = useState({
        fullName: 'Alexander Banner',
        email: 'alexander.banner@gmail.com',
        phone: '4912345678',
    });

    const [profileImage, setProfileImage] = useState(null); // image file
    const [previewImage, setPreviewImage] = useState(null); // preview URL

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handlePhoneChange = (value) => {
        setFormData((prev) => ({ ...prev, phone: value }));
    };

    const validate = () => {
        const errs = {};
        if (!formData.fullName.trim()) errs.fullName = 'Full name is required.';
        if (!formData.email.trim()) {
            errs.email = 'Email is required.';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errs.email = 'Enter a valid email address.';
        }
        if (!formData.phone) errs.phone = 'Phone number is required.';
        setErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(file);
            setPreviewImage(URL.createObjectURL(file)); // optional preview
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validate()) return;


        setTimeout(() => {
            handleClose();
        }, 3000);
    };

    return (
        <>
            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Profile</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form onSubmit={handleSubmit}>

                        <Form.Group className="mb-3" controlId="formImage">
                            {previewImage && (
                                <div className="mt-2 text-center">
                                    <Image
                                        src={previewImage}
                                        alt="Preview"
                                        roundedCircle
                                        width={100}
                                        height={100}
                                    />
                                </div>
                            )}
                            <Form.Label>Profile Image</Form.Label>
                            <Form.Control
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                            />

                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formName">
                            <Form.Label>Full name</Form.Label>
                            <Form.Control
                                type="text"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                isInvalid={!!errors.fullName}
                                placeholder="Enter name"
                            />
                            <Form.Control.Feedback type="invalid" className="d-block">
                                {errors.fullName}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                disabled
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formPhone">
                            <Form.Label>Phone number</Form.Label>
                            <PhoneInput
                                country={'us'}
                                value={formData.phone}
                                onChange={handlePhoneChange}
                                inputStyle={{ width: '100%' }}
                                inputProps={{
                                    name: 'phone',
                                }}
                                containerClass={errors.phone ? 'is-invalid' : ''}
                            />
                            {errors.phone && (
                                <div className="invalid-feedback d-block">{errors.phone}</div>
                            )}
                        </Form.Group>

                        <Button type="submit" className="w-100 mt-3">
                            Save
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default EditProfileModal;
